import { createTheme } from "@mui/material/styles";

// The click dummy's two faces, with the same fallback stack it names. Body copy
// is Figtree; headings are Bricolage Grotesque. Both are loaded by index.html.
const fontFamily =
  '"Figtree", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';
const displayFamily =
  '"Bricolage Grotesque", ui-sans-serif, system-ui, sans-serif';

// The dummy's neutrals. Structural, not tenant branding: a tenant supplies only
// the primary and secondary, and these keep every screen readable whichever
// pair it supplies. Spread into both themes below so the tenant palette cannot
// silently drop them.
const neutralPalette = {
  background: { default: "#F3F4F6", paper: "#FFFFFF" },
  text: { primary: "#16201B", secondary: "#5A6560" },
  divider: "#E0E5E2",
  error: { main: "#B93228" },
  success: { main: "#1C7A4B" },
  warning: { main: "#8F5A00" },
};

const baseTheme = createTheme({
  typography: {
    fontFamily,
    fontSize: 15,
    h1: { fontFamily: displayFamily },
    h2: { fontFamily: displayFamily },
    h3: { fontFamily: displayFamily },
    h4: { fontFamily: displayFamily },
    h5: { fontFamily: displayFamily },
    h6: { fontFamily: displayFamily },
    // Sentence case everywhere: the journey's own buttons already switched
    // MUI's capitals off one by one, so the two styles met on one page.
    button: { fontFamily, textTransform: "none" },
  },
  palette: neutralPalette,
});

// The primary matches the blue in the shipped Maviance logo assets. The
// secondary is a pale tint of it because this slot fills instruction surfaces
// behind text, not calls to action — see MPAY-32043 for the measurements.
export const FALLBACK_PRIMARY = "#0D109F";
export const FALLBACK_SECONDARY = "#EEF0FB";
export const FALLBACK_TERTIARY = "#0D109F";

export const createTenantMuiTheme = (
  primary?: string,
  secondary?: string
) => {
  return createTheme({
    ...baseTheme,
    palette: {
      ...neutralPalette,
      // MUI's default of 3 put white text on bright tenant greens at 3.2:1;
      // 4.5 is the WCAG minimum for normal text.
      contrastThreshold: 4.5,
      primary: {
        main: primary || FALLBACK_PRIMARY,
      },
      secondary: {
        main: secondary || FALLBACK_SECONDARY,
      },
    },
  });
};

const theme = createTenantMuiTheme();

export default theme;

